export const analyticsData = {
  footerInteraction: {
    subscribeEmail: {
      event: 'Event_Subscribe',
      category: 'Footer Interaction',
      action: 'Subscribe',
      label: '',
    },
    dctLogoClick: {
      event: 'Event_LogoClick',
      category: 'Footer Interaction',
      action: 'Icon Click',
      label: 'dct logo',
    },
  },
  headerInteraction: {
    searchClick: {
      event: 'Event_Search',
      category: 'Header Interaction',
      action: 'Search',
      label: '',
    },
    dctLogoClick: {
      event: 'Event_LogoClick',
      category: 'Header Interaction',
      action: 'Icon Click',
      label: 'dct logo',
    },
    toggleLanguage: {
      event: 'Event_LanguageToggle',
      category: 'Header Interaction',
      action: 'Select Language',
      label: 'en|ar',
    },
    videoPlayClick: {
      event: 'Event_VideoPlay',
      category: 'Header Interaction',
      action: 'Video Play',
      label: 'Complete Ad Experience - Golf in AD',
    },
    changeLanguage: {
      event: 'language_change',
      language_selected: 'en',
    },
    navLinkClick: {
      event: 'top_nav_interaction',
      call_to_action: '',
      nav_category: '',
    },
  },
  pageBodyInteraction: {
    addToCalendar: {
      event: 'Event_AddToCalendar',
      category: 'Page Body Interaction',
      action: 'Icon Click',
      label: 'AddToCalendar_{{Event Name}}',
    },
    backToTopClick: {
      event: 'Event_BackToTop',
      category: 'Footer Interaction',
      action: 'Button Click',
      label: 'Scroll Button',
    },
    dctLogoClick: {
      event: 'Event_LogoClick',
      category: 'Page Body Interaction',
      action: 'Icon Click',
      label: 'dct logo',
    },
    contactFormsClick: {
      event: 'Event_SendFeedback',
      category: 'Page Body Interaction',
      action: 'Send Feedback',
      label: '',
    },
    arrowClick: {
      event: 'Event_ArrowClick',
      category: 'Page Body Interaction',
      action: 'Link Clicks',
      label: '',
    },
    tileClick: {
      event: 'Event_TileClick',
      category: 'Page Body Interaction',
      action: 'Tile Click',
      label: '',
    },
    favoriteNavTileClick: {
      event: 'Event_Favorite_Navigation_Tile_Click',
      category: 'Page Body Interaction',
      action: 'Favorite Nav Tile Click',
      label: '',
    },
    addItemToFavorite: {
      event: 'Event_Add_Item_Favorite_Click',
      category: 'Page Body Interaction',
      action: 'Add item to Favorite Click',
      label: '',
    },
    removeItemToFavorite: {
      event: 'Event_Remove_Item_Favorite_Click',
      category: 'Page Body Interaction',
      action: 'Remove item to Favorite Click',
      label: '',
    },
    findDealClicks: {
      event: 'Event_FindDeals',
      category: 'Page Body Interaction',
      action: '',
      label: '',
    },
    ticketBookingForm: {
      event: 'Event_TicketBookingForm',
      category: 'Page Body Interaction',
      action: 'Ticket Booking Form Submit',
      label: '',
    },
    filterBtnClick: {
      event: 'Event_FilterButton',
      category: 'Page Body Interaction',
      action: 'Filter',
      label: '',
    },
    filterMobileBtnClick: {
      event: 'Event_FilterButton',
      category: 'Page Body Interaction',
      action: 'Filter-Mobile',
      label: '',
    },
    seeAllPhotosBtnClick: {
      event: 'Event_SeeAllPhotos',
      category: 'Page Body Interaction',
      action: 'See All Photos',
      label: '',
    },
    galleryImageClick: {
      event: 'Event_GalleryClick',
      category: 'Page Body Interaction',
      action: 'Image Click',
      label: 'Complete Ad Experience - Golf in AD',
    },
    galleryVideoClick: {
      event: 'Event_GalleryClick',
      category: 'Page Body Interaction',
      action: 'Video Click',
      label: 'Complete Ad Experience - Golf in AD',
    },
    videoPlayClick: {
      event: 'Event_VideoPlay',
      category: 'Page Body Interaction',
      action: 'Video Play',
      label: 'Complete Ad Experience - Golf in AD',
    },
    swipeArrowClick: {
      event: 'Event_Swipe',
      category: 'Page Body Interaction',
      action: 'Swipe',
      label: 'Serenity Of AD Desert',
    },
    loadMoreBtnClick: {
      event: 'Event_LoadMore',
      category: 'Page Body Interaction',
      action: 'Load More',
      label: 'Hottest Spots in AD - Load More',
    },
    backToHomeLinkClick: {
      event: 'Event_Oops-Homepage',
      category: 'Page Body Interaction',
      action: 'Back To Homepage',
      label: 'Louvre Oops Page',
    },
    thingsToDoOOpsLink: {
      event: 'Event_Oops-Travel',
      category: 'Page Body Interaction',
      action: 'Things To Do',
      label: 'Louvre Oops Page ',
    },
    readMoreBtnClick: {
      event: 'Event_ReadMore',
      category: 'Page Body Interaction',
      action: 'Read More Click',
      label: 'Yas Links Abu Dhabi',
    },
    visitWebsiteClick: {
      event: 'Event_VisitWebsite',
      category: 'Page Body Interaction',
      action: 'Visit Website',
      label: '',
    },
    primaryCTAClick: {
      event: 'Event_PrimaryCTA',
      category: 'Page Body Interaction',
      action: '',
      label: '',
    },
    getDirectionsLinkClick: {
      event: 'Event_GetDirections',
      category: 'Page Body Interaction',
      action: 'Get Directions',
      label: '',
    },
    mapClick: {
      event: 'Event_MapClick',
      category: 'Page Body Interaction',
      action: 'Map Click',
      label: '',
    },
    viewItineraryMapClick: {
      event: 'Event_ViewItineraryMap',
      category: 'Page Body Interaction',
      action: 'View Itinerary Map',
      label: '',
    },
    miniNavClick: {
      event: 'Event_MiniNavClick',
      category: 'Page Body Interaction',
      action: 'Button Click',
      label: '',
    },
    rfpFormSubmit: {
      event: 'Event_RequestForProposal',
      category: 'Page Body Interaction',
      action: 'Button Click',
      label: '',
      label2: '',
    },
    temperatureToggle: {
      event: 'Event_TemparatureToggle',
      category: 'Page Body Interaction',
      action: 'Icon Click',
      label: 'C | F',
    },
    subscribeCompetition: {
      event: 'Event_Subscribe',
      category: 'Page Body Interaction',
      action: 'Subscribe',
      label: '',
    },
    dualHeroSwitchSlideClick: {
      event: 'Event_Dual_Hero_Switch_Slide_Click',
      category: 'Page Body Interaction',
      action: 'Swipe',
      label: 'Serenity Of AD Desert',
    },
    dualHeroSwipeInnerSlideClick: {
      event: 'Event_Dual_Hero_Swipe_Inner_Slide_Click',
      category: 'Page Body Interaction',
      action: 'Link Clicks',
      label: '',
    },
    whereToGoLink: {
      event: 'Event_Where_To_GO_Page',
      category: 'Page Body Interaction',
      action: 'Where To Go',
      label: '',
    },
    multiFilterBtnClick: {
      event: 'Event_ButtonClick',
      category: 'Page Body Interaction',
      action: 'Button Click',
      label: '',
    },
    mapInteraction: {
      event: 'Event_Map_Interaction_TitleClick',
      category: 'Page Body Interaction',
      action: 'Button Click',
      label: ''
    },
    mapInteractionButton: {
      event: 'Event_Map_Interaction_ButtonClick',
      category: 'Page Body Interaction',
      action: 'Explore Button Click',
      label: ''
    },
    signUpFormMailchinmp: {
      event: 'Event_SignUpForm_ButtonClick',
      category: 'Page Body Interaction',
      action: 'SignUp Button Click',
      label: '',
      name: '',
      email: ''
    },
    mapActivitySearch: {
      event: 'map_activity_search',
      map_activity: '',
    },
    mapCategorySearch: {
      event: 'map_category_search',
      map_category: [],
    },
    destinationSelect: {
      event: 'map_destination_search',
      map_destination: '',
    },
    eventClick: {
      event: 'map_event_click',
      map_event: '',
    },
    bookNowCTA: {
      event: 'book_now',
      cta_location: '',
    },
    viewDetailsCTA: {
      event: 'view_details',
      cta_location: '',
    },
    kioskmapActivitySearch: {
      event: 'kiosk_map_activity_search',
      map_activity: '',
    },
    kioskmapCategorySearch: {
      event: 'kiosk_map_category_search',
      map_category: [],
    },
    kioskdestinationSelect: {
      event: 'kiosk_map_destination_search',
      map_destination: '',
    },
    kioskeventClick: {
      event: 'kiosk_map_event_click',
      map_event: '',
    },
    kioskbookNowCTA: {
      event: 'kiosk_map_book_now',
      cta_location: '',
    },
    kioskviewDetailsCTA: {
      event: 'kiosk_map_view_details',
      cta_location: '',
    },
    cta_click: {
      event: 'cta_click',
      cta_location: '',
      cta_name: '',
      cta_type: '',
    },
    popup_interaction: {
      event: 'popup_interaction',
      cta_location: '',
      cta_name: 'view_all_events',
    },
    subscribed: {
      event: 'subscribed',
      hash_first_name: '',
      hash_last_name: '',
      hash_email: '',
      form_country: ''
    },
    social_handle: {
      event: 'social_handle',
      social_channel_name: ''
    },
    itinerary_interaction: {
      event: 'itinerary_interaction',
      trip_date: '',
      trip_duration: ''
    },
    itinerary_add_places: {
      event: 'itinerary_add_places',
    },
    itinerary_add_activity: {
      event: 'itinerary_add_activity',
      venue_name: ''
    },
    add_places_cta: {
      event: 'add_places_cta',
      venue_names: []
    },
    sideNavClick: {
      event: 'Event_SideNavClick',
      category: 'Page Body Interaction',
      action: 'Side Navigation Click',
      label: '',
    },
    Map_3d_all_locations_click: {
      event: '3d_map_list_all_places'
    },
    Map_3d_passport_click: {
      event: '3d_map_passport_icon'
    },
    Map_3d_location_click: {
      event: '3d_map_location_click',
      '3d_map_location_name': ''
    },
    Map_3d_experience_click: {
      event: '3d_map_experience_click',
      '3d_map_location_name': '',
      '3d_map_experience_name': '',
    },
    Map_3d_video_play: {
      event: '3d_map_video_play',
      '3d_map_location_name': ''
    },
    Map_3d_visited_click: {
      event: '3d_map_have_visited',
      '3d_map_location_name': ''
    },
    Map_3d_check_out_passport: {
      event: '3d_map_check_out_passport',
      '3d_map_location_name': ''
    },
    Map_3d_want_to_visit: {
      event: '3d_map_want_to_visit',
      '3d_map_location_name': ''
    },
    Map_3d_explore_previous: {
      event: '3d_map_explore_previous',
      '3d_map_location_name': ''
    },
    Map_3d_explore_next: {
      event: '3d_map_explore_next',
      '3d_map_location_name': ''
    },
    Map_3d_share_location: {
      event: '3d_map_share_location',
      '3d_map_location_name': '',
      social_platform_name: '',
    },
  },
  dataIds: {
    headerNavLinkClick: 'header_nav_linkclick',
    footerNavLinkClick: 'footer_nav_linkclick',
    footerNavAppclick: 'footer_nav_appclick',
    footerNavIconclick: 'footer_nav_iconclick',
    topNavLinkClick: 'top_nav_linkclick',
    pageBodyNavLinkClick: 'pagebody_nav_linkclick',
    pageBodyNavAppClick: 'pagebody_nav_appclick',
  },
  dataLinksText: {
    quickLinks: 'QuickLinks',
    downloadapp: 'Download App',
    followus: 'Followus',
    contactByPhone: 'Contact Us - Phone',
    contactByEmail: 'Contact Us - Email',
    downloadText: 'Download',
    siteMapText: 'SiteMap',
    breadCrumbLink: 'BreadCrumb',
    hotelFormText: 'Hotel',
    flightFormText: 'Flight',
    socialShare: 'Social-Share',
    findDeals: 'Find Deals',
    checkedText: 'Checked',
    uncheckedText: 'Unchecked',
    outlook: 'Outlook',
    gmail: 'Gmail',
    addToCalendar: 'AddToCalendar',
    temperatureCelsius: 'C',
    temperatureFahrenheit: 'F',
  },
};
